<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    lazy-validation
  >
    <div class="text-center mb-4">
      <a
        :href="appUrl"
        target="_blank"
      >
        <img
          alt="app-logo"
          class="app-logo"
          :src="appLogo"
        />
      </a>
    </div>

    <span
      class="h4 font-weight-light my-5"
      v-html="$t('views.signup_in.dont_have_account')"
    >
    </span>
    <span>
      <router-link
        to="/signup"
        class="text-decoration-underline ml-3"
        text
      >
        {{ $t("views.signup_in.signup") }}
      </router-link>
    </span>

    <v-text-field
      validate-on-blur
      v-model="email"
      name="email"
      :label="$t('commons.email')"
      :rules="rules.email"
      autofocus
      class="input-group--focused"
    />
    <v-text-field
      validate-on-blur
      v-model="password"
      name="password"
      :rules="rules.password"
      :type="passwordType"
      autocomplete="off"
      :label="$t('commons.pwd')"
      :append-icon="eyeIcon"
      @keyup.enter="submit"
      @click:append="togglePassword"
    />
    <v-btn
      large
      block
      :disabled="loading"
      :loading="loading"
      color="black white--text"
      class="my-3"
      @click="submit"
    >
      {{ $t("views.signup_in.signin") }}
    </v-btn>
    <div class="d-flex flex-wrap">
      <ForgottenPasswordDialog />
      <ResendActivationEmail />
    </div>

    <div v-if="!$vuetify.breakpoint.smAndDown" class="text-center mt-6">
      <v-btn
        :href="newVersionUrl"
        target="_blank"
        color="primary"
        block
        large
        class="text-none white--text new-version-btn"
      >
        <v-icon left>mdi-rocket-launch</v-icon>
        Tester la nouvelle version
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import ForgottenPasswordDialog from "@/components/utils/ForgottenPasswordDialog.vue"
import ResendActivationEmail from "@/components/utils/ResendActivationEmail.vue"
import { required, email } from "@/utils/validator"
import { AccountService } from "@/services"
export default {
  components: {
    ForgottenPasswordDialog,
    ResendActivationEmail
  },
  data: function () {
    return {
      // appLogo: this.$appConfig.assets.img.custom.logo,
      appUrl: this.$appConfig.url,
      loading: false,
      email: "",
      password: "",
      eyeIcon: "mdi-eye",
      passwordType: "password",
      isFormValid: false,
      rules: {
        email: [required, email],
        password: [required]
      }
    }
  },
  mounted: function () {
    this.$refs.form.reset()
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    },
    appLogo() {
      return this.isThemeDark
        ? this.$appConfig.assets.img.custom.logo_white
        : this.$appConfig.assets.img.custom.logo
    },
    newVersionUrl() {
      return process.env.VUE_APP_NEW_VERSION_URL || "https://new.gwassou.com"
    }
  },
  methods: {
    submit() {
      if (this.loading) return
      this.$refs.form.validate()
      this.$nextTick(() => {
        if (this.isFormValid) {
          this.call_login()
        }
      })
    },
    call_login() {
      let credentials = {
        email: this.email,
        password: this.password
      }

      this.loading = true
      AccountService.login(this, credentials, this.$route.query.redirect).finally(() => {
        this.loading = false
      })
    },
    clear() {
      this.$refs.form.reset()
      this.email = ""
      this.password = ""
      this.checkbox = null
    },
    togglePassword() {
      this.passwordType = this.passwordType == "password" ? "text" : "password"
      this.eyeIcon = this.eyeIcon == "mdi-eye" ? "mdi-eye-off" : "mdi-eye"
    }
  }
}
</script>

<style scoped>
.app-logo {
  height: 120px;
  max-width: 100%;
  object-fit: contain;
}

@media (max-width: 960px) {
  .app-logo {
    height: 80px;
  }
}

.new-version-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35);
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35);
  }
  50% {
    box-shadow: 0 4px 20px rgba(25, 118, 210, 0.6);
  }
}
</style>
